import ('mapbox-gl/dist/mapbox-gl.css')

import ('./style.css')

import Map from './map'

export default Map